import * as Types from '../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type MeForAuthContextQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MeForAuthContextQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, phone: string | null, email: string | null, activeRole: Types.Role, roles: Array<Types.Role>, providers: Array<{ __typename?: 'Provider', id: string, fullName: string }> | null }, viewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, referrer: string | null, landingUrl: string | null } } | null };

export type UpdateSessionCustomerMutationVariables = Types.Exact<{
  userId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  referrer?: Types.InputMaybe<Types.Scalars['String']['input']>;
  landingUrl?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateSessionCustomerMutation = { __typename?: 'Mutation', updateSessionCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, referrer: string | null, landingUrl: string | null } } };

export type ResumableSchoolEnrollmentsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type ResumableSchoolEnrollmentsQuery = { __typename?: 'Query', resumableSchoolEnrollments: Array<{ __typename?: 'EnrollmentItem', id: string, updatedAt: string, program: { __typename?: 'Program', id: string, name: string, slug: string, vocationId: string, vocation: { __typename?: 'Vocation', id: string, adjective: string } }, provider: { __typename?: 'Provider', id: string, fullName: string, slug: string, logoImageFile: { __typename?: 'ImageFile', id: string, url: string | null } | null } }> };


export const MeForAuthContextDocument = gql`
    query meForAuthContext {
  me {
    id
    nameFirst
    nameLast
    phone
    email
    activeRole
    roles
    providers {
      id
      fullName
    }
  }
  viewerCustomer {
    id
    detailsMap {
      id
      referrer
      landingUrl
    }
  }
}
    ` as unknown as DocumentNode<MeForAuthContextQuery, MeForAuthContextQueryVariables>;
export const UpdateSessionCustomerDocument = gql`
    mutation updateSessionCustomer($userId: String, $referrer: String, $landingUrl: String) {
  updateSessionCustomer(
    userId: $userId
    referrer: $referrer
    landingUrl: $landingUrl
  ) {
    id
    detailsMap {
      id
      referrer
      landingUrl
    }
  }
}
    ` as unknown as DocumentNode<UpdateSessionCustomerMutation, UpdateSessionCustomerMutationVariables>;
export const ResumableSchoolEnrollmentsDocument = gql`
    query resumableSchoolEnrollments($customerId: ID!) {
  resumableSchoolEnrollments(customerId: $customerId) {
    id
    updatedAt
    program {
      id
      name
      slug
      vocationId
      vocation {
        id
        adjective
      }
    }
    provider {
      id
      fullName
      slug
      logoImageFile {
        id
        url
      }
    }
  }
}
    ` as unknown as DocumentNode<ResumableSchoolEnrollmentsQuery, ResumableSchoolEnrollmentsQueryVariables>;